import { useEffect, useState } from "react";
import axios from "../../api/axios";
import SidebarAdmin from "../../components/SidebarAdmin";
import { formatLocalDateTime } from "../../utils/dateTime";

export default function SessionMonitor() {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchSessions = async () => {
    try {
      const res = await axios.get("/admin/whatsapp-sessions");
      setSessions(res.data);
    } catch (err) {
      console.error("Failed to fetch sessions:", err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSessions();
    const interval = setInterval(fetchSessions, 10000); // Refresh every 10s
    return () => clearInterval(interval);
  }, []);

  const onlineCount = sessions.filter(s => s.isOnline).length;

  return (
    <div className="flex flex-col lg:flex-row h-screen bg-gray-50">
      <SidebarAdmin />
      <div className="flex-1 p-4 md:p-6 lg:p-8 overflow-y-auto mt-14 lg:mt-0">
        <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-6 md:mb-8 gap-4">
          <div>
            <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900">WhatsApp Sessions</h1>
            <p className="text-gray-500 mt-1">Monitor all connected WhatsApp instances</p>
          </div>
          <div className="flex items-center gap-4">
            <div className="bg-green-100 text-green-700 px-4 py-2 rounded-full font-bold">
              {onlineCount} Online
            </div>
            <div className="bg-gray-100 text-gray-600 px-4 py-2 rounded-full font-bold">
              {sessions.length} Total
            </div>
          </div>
        </div>

        {loading ? (
          <div className="flex justify-center py-20">
            <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
          </div>
        ) : (
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-x-auto">
            <table className="min-w-[720px] w-full">
              <thead className="bg-gray-900 text-white text-xs uppercase tracking-wider">
                <tr>
                  <th className="p-4 text-left">User</th>
                  <th className="p-4 text-left">Phone Number</th>
                  <th className="p-4 text-center">Status</th>
                  <th className="p-4 text-left">Last Connected</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {sessions.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="p-8 text-center text-gray-400">
                      No WhatsApp sessions found
                    </td>
                  </tr>
                ) : (
                  sessions.map((session) => (
                    <tr key={session.id} className="hover:bg-gray-50 transition">
                      <td className="p-4">
                        <p className="font-bold text-gray-800">{session.name || "N/A"}</p>
                        <p className="text-xs text-gray-400">{session.email}</p>
                      </td>
                      <td className="p-4 font-mono text-gray-600">
                        {session.phoneNumber ? `+${session.phoneNumber}` : "—"}
                      </td>
                      <td className="p-4 text-center">
                        <span className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-bold ${
                          session.isOnline 
                            ? "bg-green-100 text-green-700" 
                            : "bg-gray-100 text-gray-500"
                        }`}>
                          <span className={`w-2 h-2 rounded-full ${
                            session.isOnline ? "bg-green-500 animate-pulse" : "bg-gray-400"
                          }`} />
                          {session.isOnline ? "Online" : "Offline"}
                        </span>
                      </td>
                      <td className="p-4 text-gray-500 text-sm">
                        {session.last_connected 
                          ? formatLocalDateTime(session.last_connected)
                          : "Never"
                        }
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
